/* file description */
import { GroupDataProps } from '../type';

interface UseColapseProps {
  extral: any;
  isOpenGroup?: boolean;
  RecordFormColumns: any;
  groupData?: GroupDataProps[];
}

export const useCollapse = ({
  extral,
  isOpenGroup,
  RecordFormColumns,
  groupData,
}: UseColapseProps) => {
  if (!isOpenGroup || !groupData || groupData?.length === 0) {
    return {
      mergeRecordColumnsList: [],
    };
  }
  const collapseList = groupData.map((data) => {
    // const renderSchema = data.values.map((value => {
    //   return RecordFormColumns?.find((item:any) => item?.dataIndex === value.name)
    // }))
    // 联动展示字段加入groupData
    const renderSchema: any[] = [];
    data.values.forEach((value) => {
      RecordFormColumns.forEach((item: any) => {
        if (item?.dataIndex === value.name) {
          renderSchema.push(item);
        }
        if (item?.moduleField?.linkBy === value.name) {
          renderSchema.push(item);
        }
      });
    });
    return {
      ...data,
      renderSchema,
      type: 'schemaform',
    };
  });
  if (extral && Object.keys(extral).length !== 0) {
    for (const key in extral) {
      if (Number(key) >= 1) {
        collapseList.splice(Number(key), 0, { type: 'slot', ...extral[key] });
      } else {
        collapseList.unshift({ type: 'slot', ...extral[key] });
      }
    }
  }

  return {
    mergeRecordColumnsList: collapseList,
  };
};

